import Donate from "./Donate";

export default Donate;
